import HCLTreeVertexValue, {HCLTreeVertexValueJSON} from '../../HCLTreeVertexValue/HCLTreeVertexValue';
import Label from "../../HCLTreeVertexValue/Label";
import Instruction from "../../HCLTreeVertexValue/Instruction";

class FunctionalEventVertexValue extends HCLTreeVertexValue {

  private instructions: Instruction[];
  private branchKey: string;

  /**
   * @param {Label} label
   * @param {Instruction[]} instructions
   * @param {string} branchKey
   */
  constructor(label?: Label, instructions?: Instruction[], branchKey?: string) {
    super(label || new Label("Functional Event", "Description for Functional Event"));
    this.instructions = instructions || [new Instruction()];
    this.branchKey = branchKey;
  }

  /**
   * @return {Instruction[]}
   */
  getInstructions(): Instruction[] {
    return this.instructions;
  }

  /**
   * @param {Instruction[]} instructions
   */
  setInstructions(instructions: Instruction[]): void {
    this.instructions = instructions;
  }

  /**
   * @return {string}
   */
  getBranchKey() {
    return this.branchKey;
  }

  /**
   * @param {string} branchKey
   * @throws An error if branch key already exists
   */
  setBranchKey(branchKey: string) {
    this.branchKey = branchKey;
  }

  clone(): FunctionalEventVertexValue {
    return new FunctionalEventVertexValue(this.label.clone(), this.instructions.map(instruction => instruction.clone()), null);
  }

}

export default FunctionalEventVertexValue;
export {FunctionalEventVertexValue};
